var _g, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_3936_841)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.2075,
    y: 42.2065,
    width: 66.5868,
    height: 66.5868,
    rx: 16.5156,
    stroke: "#9292AF",
    strokeWidth: 0.524306,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.262153,
    y: 0.262153,
    width: 150.476,
    height: 150.476,
    rx: 58.4601,
    stroke: "#0F172A",
    strokeWidth: 0.524306
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.7465,
    y: 10.7485,
    width: 129.503,
    height: 129.503,
    rx: 47.974,
    stroke: "#0F172A",
    strokeWidth: 0.524306
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 21.2348,
    y: 21.2343,
    width: 108.531,
    height: 108.531,
    rx: 37.4878,
    stroke: "#0F172A",
    strokeWidth: 0.524306
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7192,
    y: 31.7206,
    width: 87.559,
    height: 87.559,
    rx: 27.0017,
    stroke: "#0F172A",
    strokeWidth: 0.524306
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.635 63.9661L82.3197 76.6764L79.427 82.4983L77.7575 85.8584L77.7319 85.8504C77.6629 85.9759 77.5908 86.0994 77.5165 86.221C76.7422 87.4925 75.6845 88.5685 74.4378 89.3573C72.9943 90.2663 71.2935 90.792 69.4733 90.792C66.321 90.792 63.529 89.2166 61.8064 86.7937C60.6691 85.1939 60 83.225 60 81.0976C60 81.0877 60 81.0774 60.0004 81.0675C60.0038 79.8146 60.2406 78.6167 60.6672 77.5186C60.8102 77.1484 60.9753 76.7889 61.161 76.4427C61.1632 76.4381 61.1655 76.4335 61.1682 76.4294L61.3931 76.0332L64.5043 70.5521H64.5047L68.4462 63.3828L71.6561 68.9706L71.3667 69.4945L70.9301 70.2841L70.285 71.4386C70.2873 71.439 70.2896 71.439 70.2919 71.4393L66.4522 78.3868L65.6439 79.8482C65.4872 80.3461 65.4235 80.8871 65.4689 81.4495C65.6252 83.4035 67.1545 84.9945 69.0612 85.1889C69.776 85.2618 70.4574 85.1428 71.0621 84.8759C71.8738 84.5171 72.5303 83.8678 72.9581 83.076L73.2132 82.6036L75.2316 78.866L76.1748 76.8365L79.0397 70.6703L82.1542 63.9661L88.635 63.9661Z",
    fill: "#100459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9283 70.2842L70.2901 71.4394C70.2878 71.439 70.2855 71.439 70.2832 71.4387L70.9283 70.2842Z",
    fill: "#100459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.391 76.0332L61.166 76.4293C61.2377 76.2951 61.3128 76.1632 61.391 76.0332Z",
    fill: "#100459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0388 70.6702L76.174 76.8364L71.6552 68.9705L68.4453 63.3827C69.9136 60.7531 73.6237 60.7672 75.0725 63.4082L79.0388 70.6702Z",
    fill: "#683FEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1416 90.9996H84.3098L79.4258 82.4977L82.3184 76.6758L90.1416 90.9996Z",
    fill: "#683FEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1678 76.4297C61.1651 76.4339 61.1628 76.4385 61.1605 76.443H61.1602L61.1678 76.4297Z",
    fill: "#100459"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1423 61.002L89.9646 61.3504H83.334L83.4953 61.002H90.1423Z",
    fill: "#683FEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7272 61.8154L89.5495 62.1639H82.957L83.1183 61.8154H89.7272Z",
    fill: "#683FEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3117 62.6279L89.1337 62.9764H82.5801L82.7414 62.6279H89.3117Z",
    fill: "#683FEA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8978 63.4414L88.7202 63.7899H82.2051L82.3664 63.4414H88.8978Z",
    fill: "#683FEA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8962 63.4414L88.7185 63.7899L82.2012 63.7948L82.2035 63.7899L82.3647 63.4414H88.8962Z",
    fill: "#683FEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3117 62.6279L89.1337 62.9764H82.5801L82.7414 62.6279H89.3117Z",
    fill: "#683FEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7272 61.8154L89.5495 62.1639H82.957L83.1183 61.8154H89.7272Z",
    fill: "#683FEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1434 61L90.1423 61.0019L89.9646 61.3504H83.334L83.4953 61.0019L83.496 61H90.1434Z",
    fill: "#683FEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_3936_841",
    x: 31.9835,
    y: 41.42,
    width: 87.0349,
    height: 90.7051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.524306,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3936_841"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3936_841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3936_841",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.524306,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_3936_841"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.524306
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.262153
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.780392 0 0 0 0 0.780392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3936_841"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.524306,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_3936_841"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.524306
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.262153
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.780392 0 0 0 0 0.780392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3936_841",
    result: "effect3_innerShadow_3936_841"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCenterIcon);
export default __webpack_public_path__ + "static/media/mob-center-icon.b0d751fb8be0b27f2b81a4dba3f81a99.svg";
export { ForwardRef as ReactComponent };